export enum BrowseParamNames {
  WorkspaceId = 'workspaceId',
  SearchQuery = 'q',
  LibraryId = 'libraryId',
  BoardId = 'boardId',
  ClipId = 'clipId',
}
